import { Link } from "react-router-dom";
import ArmeriaLayout from "./ArmeriaLayout";
import { listTools } from "./armeriaConfig";
import { ArrowRight } from "lucide-react";
import "./armeria.css";

const CATEGORY_LABELS = {
  voz: "Voz editorial",
  estrategia: "Estrategia",
  seo: "SEO y visibilidad",
  creatividad: "Creatividad",
};

export default function ArmeriaIndex() {
  const tools = listTools();

  return (
    <ArmeriaLayout showBack={false}>
      {/* Hero */}
      <div style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: "40px", alignItems: "center", marginBottom: "56px" }}>
        <div>
          <span className="arm-badge">7 herramientas · 100% gratuitas</span>
          <h1 style={{ fontSize: "56px", lineHeight: "1", margin: "16px 0 20px" }}>
            La Armería
          </h1>
          <p style={{ fontSize: "20px", lineHeight: "1.5", color: "#a89b83", marginBottom: "20px", fontFamily: "'DM Sans', sans-serif" }}>
            El taller del <strong style={{ color: "#c8922a" }}>Maestro Armero</strong>.
            Herramientas afiladas para analizar tu voz, tu contenido y tu estrategia editorial.
          </p>
          <p style={{ fontSize: "15px", color: "#a89b83", lineHeight: "1.6" }}>
            Sin límites de uso. Sin tarjeta. Solo un email para ver los resultados.
          </p>
        </div>
        <div style={{ textAlign: "center" }}>
          <img
            src="https://alianzaempresarial.eu/wp-content/uploads/2026/05/Armero-cuerpo.jpeg"
            alt="El Maestro Armero"
            style={{
              width: "100%", maxWidth: "360px", height: "auto",
              borderRadius: "12px", border: "1px solid rgba(200,146,42,0.35)",
              boxShadow: "0 20px 60px rgba(0,0,0,0.5), 0 0 40px rgba(200,146,42,0.15)"
            }}
            data-testid="armeria-master-image"
          />
        </div>
      </div>

      {/* Tools grid */}
      <div>
        <h2 style={{ fontSize: "28px", marginBottom: "24px" }}>Las herramientas</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: "20px" }}>
          {tools.map((tool) => (
            <Link
              key={tool.id}
              to={`/armeria/${tool.id}`}
              className="arm-card"
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "flex", flexDirection: "column", gap: "12px",
                cursor: "pointer"
              }}
              data-testid={`armeria-tool-${tool.id}`}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontSize: "32px" }}>{tool.emoji}</span>
                <span className="arm-badge" style={{ fontSize: "10px" }}>{CATEGORY_LABELS[tool.category] || tool.category}</span>
              </div>
              <h3 style={{ fontSize: "20px", margin: 0, color: "#f5efe4", fontFamily: "'Playfair Display', serif" }}>
                {tool.title}
              </h3>
              <p style={{ color: "#a89b83", fontSize: "14px", lineHeight: "1.45", margin: 0, flexGrow: 1 }}>
                {tool.tagline}
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#c8922a", fontSize: "13px", fontWeight: 500, marginTop: "8px" }}>
                Abrir herramienta <ArrowRight size={14} />
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Bottom CTA */}
      <div style={{ marginTop: "56px", textAlign: "center", padding: "32px 24px", border: "1px solid rgba(200,146,42,0.22)", borderRadius: "14px", background: "rgba(200,146,42,0.03)" }}>
        <p style={{ fontSize: "16px", color: "#f5efe4", marginBottom: "12px", fontFamily: "'Playfair Display', serif", fontStyle: "italic" }}>
          "El Armero afila las herramientas. Tú forjas el contenido."
        </p>
        <Link to="/" className="arm-btn-outline" style={{ display: "inline-block", textDecoration: "none" }}>
          Descubre La Forja de Contenidos →
        </Link>
      </div>
    </ArmeriaLayout>
  );
}
